import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './MyCourses.css';

const MyCourses: React.FC = () => {
  const navigate = useNavigate();

  const courses = [
    { id: 1, title: 'Advanced Mathematics', progress: 65, instructor: 'Dr. Smith', status: 'In Progress' },
    { id: 2, title: 'English Literature', progress: 100, instructor: 'Prof. Johnson', status: 'Completed' },
    { id: 3, title: 'Computer Science Basics', progress: 30, instructor: 'Dr. Williams', status: 'In Progress' },
    { id: 4, title: 'Spanish for Beginners', progress: 0, instructor: 'Ms. Garcia', status: 'Not Started' }
  ];

  return (
    <div className="my-courses-page">
      <header className="my-courses-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>My Courses</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="my-courses-content">
        {courses.map((course) => (
          <div key={course.id} className="course-item">
            <div className="course-image">
              <div className="course-placeholder">📚</div>
            </div>
            <div className="course-details">
              <h3 className="course-title">{course.title}</h3>
              <p className="course-instructor">{course.instructor}</p>
              <div className="course-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${course.progress}%` }}
                  ></div>
                </div>
                <span className="progress-text">{course.progress}%</span>
              </div>
              <span className={`course-status ${course.status.toLowerCase().replace(' ', '-')}`}>
                {course.status}
              </span>
            </div>
            <button className="continue-button">Continue</button>
          </div>
        ))}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default MyCourses;

